<template>
  <a :href="href" class="album" @click.prevent="$emit('getIdGalery', { id: idGallery, title: imagetitle })">
    <span class="album-media">
      <img v-img-fallback v-if="imageSrc && !error" :src="imagen" :alt="imagetitle" loading="lazy" @error="error = true" />
      <span v-else class="album-placeholder">
        <span class="material-symbols-outlined">photo_library</span>
      </span>
      <span class="album-shade"></span>
      <span class="album-info">
        <span class="album-title">{{ imagetitle }}</span>
        <span v-if="imageDescription" class="album-desc">{{ imageDescription }}</span>
        <span class="album-cta">
          Ver álbum <span class="material-symbols-outlined">arrow_forward</span>
        </span>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  name: "cardView",
  props: ["imageSrc", "imagetitle", "imageDescription", "idGallery"],
  data() {
    return {
      error: false,
      base: this.$media,
    };
  },
  computed: {
    imagen() {
      return this.imageSrc.startsWith("http") ? this.imageSrc : `${this.base}/img/minGallery/${this.imageSrc}`;
    },
    href() {
      return this.$router.resolve({
        name: "carrete",
        query: { id: this.idGallery, title: (this.imagetitle || "").replace(/ /g, "_") },
      }).href;
    },
  },
};
</script>

<style scoped>
.album {
  display: block;
  border-radius: var(--sd-radius);
  box-shadow: var(--sd-shadow);
  text-decoration: none;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.album:hover {
  transform: translateY(-4px);
  box-shadow: var(--sd-shadow-lg);
  text-decoration: none;
}

.album:focus-visible {
  outline: 3px solid var(--sd-primary);
  outline-offset: 3px;
}

.album-media {
  position: relative;
  display: block;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: var(--sd-radius);
  background: var(--sd-surface-2);
}

.album-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.album:hover .album-media img {
  transform: scale(1.06);
}

.album-placeholder {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--sd-primary-soft), var(--sd-gold-soft));
}

.album-placeholder .material-symbols-outlined {
  font-size: 48px;
  color: var(--sd-primary);
}

.album-shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.8) 100%);
}

.album-info {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 18px 20px;
  text-align: left;
}

.album-title {
  display: -webkit-box;
  overflow: hidden;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.album-desc {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
}

.album-cta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-height: 0;
  overflow: hidden;
  font-size: 0.85rem;
  font-weight: 600;
  color: #f3dfae;
  opacity: 0;
  transition: max-height 0.25s, opacity 0.25s;
}

.album-cta .material-symbols-outlined {
  font-size: 18px;
  color: inherit;
}

.album:hover .album-cta,
.album:focus-visible .album-cta {
  max-height: 24px;
  opacity: 1;
}

@media (hover: none) {
  .album-cta {
    max-height: 24px;
    opacity: 1;
  }
}
</style>
